<mat-drawer-container class="example-container" autosize>
  <!-- <mat-drawer #drawer class="example-sidenav" mode="over" position="end" style="width: 280px">
    <mat-nav-list>
      <a mat-list-item (click)="downloadApp()" style="height: 45px !important;">Picaggo App </a>
      <div style="position: relative; bottom: 0; width: 100%">
        <a mat-list-item (click)="goHome()" style="height: 45px !important;">Home</a>
        <a mat-list-item target="_blank" style="height: 45px !important;" href="https://picaggo.com/EULA.html">User
          Agreement</a>
        <a mat-list-item target="_blank" style="height: 45px !important;"
          href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>
        <a mat-list-item (click)="logout()" style="height: 45px !important;">Logout
        </a>
        <a style="bottom: 0;position: fixed;    font-size: 12px;
        font-style: italic;
        padding: 5px;;">App Version: {{ version }}</a>
      </div>
    </mat-nav-list>
  </mat-drawer> -->

  <div class="example-sidenav-content">
    <!-- <div class="container-fluid" style="
    position: sticky;
    top: 0;
   background-color: #eb3349;
    color: white;
    z-index: 10;
    ">
      <div class="row pt-2 pb-2 align-items-center">
        <div class="col-3">
          <mat-icon class="cursor" (click)="goBack()">keyboard_backspace</mat-icon>
        </div>
        <div class="col-6 text-center">
          <img class="img-icon-css cursor" src="assets/logo white.png" alt="Picaggo" style="padding-bottom: 5px;" />
          <p style="position: relative;font-size: 12px;margin-bottom: 0px;" class="text-uppercase white-color">
            Picaggo
          </p>
        </div>
        <div class="col-3 text-end">
          <mat-icon style="z-index: 9999999" class="cursor" (click)="drawer.toggle()">menu</mat-icon>
        </div>
      </div>
    </div> -->
    <button (click)="goBack()" class="btn back-btn">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="white" />
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
        <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
    <h2 style="padding: 5px;text-align: center;">Photo-Wall Configurations - <b>{{eventName}}</b></h2>

    <mat-divider></mat-divider>
    <div class="menu-div">
      <div style="width: 20%;">
        <div class="toggle-container">
          <button (click)="toggleButtonGroup()" class="show-hide-button" mat-button
            style="text-align:left;right: -1%; color: whitesmoke;" aria-label="Slideshow"><img
              style="height: 25px;padding: 0 !important;border-radius: 0%;" src="/assets/icon/arrows.png" /></button>
        </div>
        <div class="btn-group showhide" [ngClass]="{ 'hidden': !showButtonGroup }">
          <button (click)="navigateTo('photowall/upload-qrcode')">Upload Event QR Code</button>
          <button (click)="navigateTo('photowall/add-hashtags')">Add Event Hashtags</button>
          <button (click)="navigateTo('photowall/sponsor-detail')">Add Sponsor Details</button>
          <button (click)="navigateTo('photowall/web-qr')">Web QR</button>
          <!-- <button (click)="navigateTo('add-branding')">Add Branding</button> -->
          <!-- <button>Upload Additional Information</button> -->
        </div>
      </div>
      <mat-divider vertical></mat-divider>
      <div class="content-div">

        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- <mat-drawer-container class="photowall-container">
      <mat-drawer #drawer class="photowall-sidebar" mode="side" position="start">
        <mat-nav-list>
          <a mat-list-item routerLink="upload-qrcode" routerLinkActive="active">Upload Event QR Code</a>
          <a mat-list-item routerLink="add-hashtags" routerLinkActive="active">Add Event Hashtags</a>
          <a mat-list-item routerLink="public-settings" routerLinkActive="active">Add Sponsor Details</a>
          <a mat-list-item routerLink="select-photowall" routerLinkActive="active">Upload Additional Information</a>
        </mat-nav-list>
      </mat-drawer>
    
      <div class="photowall-content">
        <mat-toolbar class="app-toolbar">
          <button mat-icon-button (click)="drawer1.toggle()" *ngIf="isSmallScreen">
            <mat-icon>menu</mat-icon>
          </button>
          <span>Photo-Wall Configurations</span>
        </mat-toolbar>
    
        <div class="content-area">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-drawer-container> -->

  </div>
</mat-drawer-container>